// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(status) {
  switch (status) {
    case "expired" :
        return /* Expired */0;
    case "pending" :
        return /* Pending */1;
    case "signed" :
        return /* Signed */2;
    default:
      return ErrorUtils$Catalyst.raiseError("TdsFormStatus.re", "Invalid tds form state", status);
  }
}

function toString(status) {
  switch (status) {
    case /* Expired */0 :
        return "expired";
    case /* Pending */1 :
        return "pending";
    case /* Signed */2 :
        return "signed";
    
  }
}

export {
  fromString ,
  toString ,
  
}
/* No side effect */
